/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList, simpleLocalAttribute } from '@touchplan/common';
import { SplitData } from '@touchplan/common';
import { IConnectedCamera } from '../interfaces/connected-camera.interface';

export enum SwimlaneRenderTypes {
	database = 'database',
	edit = 'edit',
}

export interface SwimlaneFields {
	top?: number;
	bottom?: number;
	screenTop?: number;
	screenBottom?: number;
	color?: string;
	label?: string;
	[key: string]: any;
}

export class Swimlane extends SplitData<SwimlaneFields, SwimlaneRenderTypes> {
	public camera: IConnectedCamera;

	public database: SwimlaneFields = {};
	public edit: SwimlaneFields = {};
	protected attributeList = Object.assign(generateSimplestList(['top', 'bottom', 'color', 'label']), {
		screenTop: simpleLocalAttribute,
		screenBottom: simpleLocalAttribute,
	});

	public recalcLocal(renderType?: SwimlaneRenderTypes) {
		if (!renderType) {
			renderType = this.currentRenderType;
		}
		const view = this[renderType];
		if (this.camera) {
			view.screenTop = this.camera.realToScreenY(view.top);
			view.screenBottom = this.camera.realToScreenY(view.bottom);
		}
	}

	public databaseUpdate(data: any) {
		const res = super.databaseUpdate(data);
		this.recalcLocal(SwimlaneRenderTypes.database);
		return res;
	}

	public localUpdate(data: any, renderType?: SwimlaneRenderTypes) {
		const res = super.localUpdate(data, renderType);
		this.recalcLocal(renderType);
		return res;
	}

	constructor(id: string) {
		super(id, SwimlaneRenderTypes.database);
	}
}
